import gql from 'graphql-tag';

export const ARTICLE_GROUP_QUERY = gql`
  query ArticleGroupQuery($id: ID!) {
    articleGroup(id: $id) {
      id
      title
      url
      description
      postMaloneProject {
        externalProjectId
        postMaloneAccount {
          id
          name
          externalAccountId
        }
      }
      articleGroupOgTags {
        ogArticleAuthor
        ogArticlePublishedTime
        ogArticleSection
        ogArticleTags
      }
      policy {
        canUseNonPostMaloneTextAssets
        canCreatePostMaloneProject
      }
      ogImages {
        id
        url
      }
    }
  }
`;
